/**
 * ENSD eta noise seed delta
 */

import { ensdAtom } from './atom'
import { createSliderInputComponent } from './_createSliderInputComponent'

const EnsdComp = createSliderInputComponent(
  {
    label: 'ENSD',
    atom: ensdAtom,
    helpContent: 'ENSD相同，可以让创作保持一致的eta值',
    min: 0,
    max: 65535,
    step: 1,
    digits: 0,
  },
  'Ensd'
)

export { EnsdComp }
